<template>
  <div class="card executive-card mb-4">
    <div class="card-header section-header border-0 pt-3 pb-0 px-3">
      <h5 class="section-title">Indicadores de Uso de Receitas</h5>
      <span class="section-badge">Emissao e Aderencia</span>
    </div>
    <div class="card-body pt-3">
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="tech-card">
            <div class="tech-title">Taxa de emissao por visita</div>
            <div class="tech-value">{{ indicators.emissaoPorVisita.value }}</div>
            <div class="trend trend-up">↑ {{ indicators.emissaoPorVisita.trend }}%</div>
            <div class="sparkline">
              <span
                v-for="(point, index) in indicators.emissaoPorVisita.spark"
                :key="`r-${index}`"
                :style="{ height: `${point}%` }"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="tech-card">
            <div class="tech-title">Retorno em ate 30 dias</div>
            <div class="tech-value">{{ indicators.retorno30Dias.value }}</div>
            <div class="trend trend-up">↑ {{ indicators.retorno30Dias.trend }}%</div>
            <div class="sparkline">
              <span
                v-for="(point, index) in indicators.retorno30Dias.spark"
                :key="`c-${index}`"
                :style="{ height: `${point}%` }"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="tech-card">
            <div class="tech-title">Tempo medio entre visita e emissao</div>
            <div class="tech-value">{{ indicators.tempoMedioVisitaEmissao.value }}</div>
            <div class="trend trend-good">↓ {{ Math.abs(indicators.tempoMedioVisitaEmissao.trend) }}%</div>
            <div class="sparkline sparkline-time">
              <span
                v-for="(point, index) in indicators.tempoMedioVisitaEmissao.spark"
                :key="`t-${index}`"
                :style="{ height: `${point * 30}%` }"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-xl-3 mb-3">
          <div class="tech-card">
            <div class="tech-title">Taxa de cancelamento</div>
            <div class="tech-value">{{ indicators.taxaCancelamento.value }}</div>
            <div class="trend trend-good">↓ {{ Math.abs(indicators.taxaCancelamento.trend) }}%</div>
            <div class="sparkline sparkline-cancel">
              <span
                v-for="(point, index) in indicators.taxaCancelamento.spark"
                :key="`x-${index}`"
                :style="{ height: `${point * 20}%` }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="pt-2">
        <h6 class="products-title">Produtos Mais Presentes nas Receitas Emitidas</h6>
        <div v-for="item in indicators.produtosMaisRecomendados" :key="item.name" class="product-row">
          <span>{{ item.name }}</span>
          <div class="product-bar">
            <div class="product-fill" :style="{ width: `${item.share}%` }"></div>
          </div>
          <strong>{{ item.share }}%</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExecutiveTechnicalSection',
  props: {
    indicators: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.executive-card {
  border: 1px solid #d8e5ec;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(9, 32, 58, 0.08);
}

.section-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f2b40;
}

.section-badge {
  border-radius: 999px;
  border: 1px solid #c8dae8;
  background: #f0f7fb;
  padding: 4px 10px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #2f5771;
}

.tech-card {
  border: 1px solid #dde8f0;
  border-radius: 12px;
  padding: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  box-shadow: 0 8px 18px rgba(10, 32, 58, 0.06);
}

.tech-title {
  color: #4e6477;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
}

.tech-value {
  color: #123049;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  margin-top: 8px;
}

.sparkline {
  margin-top: 8px;
  display: flex;
  gap: 6px;
  align-items: flex-end;
  height: 50px;
}

.sparkline span {
  width: 10px;
  border-radius: 4px 4px 0 0;
  background: linear-gradient(180deg, #1a8e59, #185173);
}

.sparkline-cancel span {
  background: linear-gradient(180deg, #0e5f7d, #2f7f57);
}

.sparkline-time span {
  background: linear-gradient(180deg, #1a8e59, #0d4f67);
}

.trend {
  font-size: 12px;
  font-weight: 700;
  margin-top: 2px;
}

.trend-up {
  color: #0e7a3f;
}

.trend-good {
  color: #0e7a3f;
}

.products-title {
  margin-bottom: 12px;
  color: #16344a;
  font-weight: 700;
}

.product-row {
  display: grid;
  grid-template-columns: 1fr 2fr auto;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
  color: #26465c;
}

.product-bar {
  height: 8px;
  border-radius: 999px;
  background: #e7edf2;
  overflow: hidden;
}

.product-fill {
  height: 100%;
  background: linear-gradient(90deg, #1a8d58, #0f5d7b);
}
</style>
